import TextField from "@material-ui/core/TextField";
import React from "react";
import {InputAdornment} from '@material-ui/core';

export const TextInput = ({
                                    label,
                                    input,
                                    meta: {touched, invalid, error},
                                    ...custom
                                }) => (
    <TextField
        fullWidth={true}
        label={label}
        variant='outlined'
        color='primary'
        error={touched && invalid}
        InputLabelProps={{ shrink: true }}
        helperText={touched && error}
        {...input}
        {...custom}
    />
)
export default TextInput